document.addEventListener('DOMContentLoaded', () => {

  const scrollToTop = $('.scroll-to-top');

  $(window).scroll(() => {
    const docScrollTop = $(window).scrollTop();
    // console.log(docScrollTop);
    if (docScrollTop > 500) {
      $(scrollToTop).css({ transform: 'none', opacity: 1, transition: 'transform 0.5s ease, opacity 0.5s ease' });
    } else {
      $(scrollToTop).css({ transform: 'translateY(100%)', opacity: 0, transition: 'transform 0.5s ease, opacity 0.5s ease' });
    }
  });

    scrollToTop.click(() => {

        $('html, body').animate({
            scrollTop: 0
        }, 500);

    });



});


// WEBPACK FOOTER //
// ./scripts/elements/scroll-to-top.js